import { useApi } from '@/composables/useApi'

const api = useApi()

export default function ConteudoService() {
  this.createConteudo = function (params) {
    return new Promise((resolve, reject) => {
      try {
        api.post('/createConteudo', params)
          .then(resp => {
            resolve(resp.data)
          })
      } catch (error) {
        reject(error)
      }
    })
  }

  this.UpdatConteudo = function (id, params) {
    return new Promise((resolve, reject) => {
      try {
        api.put(`/updateConteudo/${id}`, params)
          .then(resp => {
            resolve(resp.data[0])
          })
      } catch (error) {
        reject(error)
      }
    })
  }

  this.Conteudos = function () {
    return new Promise((resolve, reject) => {
      try {
        api.get('/getConteudo')
          .then(resp => {
            resolve(resp.data[0])
          })
      } catch (error) {
        reject(error)
      }
    })
  }

  this.ConteudoById = function (paramsId) {
    return new Promise(async (resolve, reject) => {
      try {
        await api.get(`getConteudoById/${paramsId}`)
          .then(resp => {
            resolve(resp.data[0])
          })
      } catch (error) {
        reject(error)
      }
    })
  }
  this.FileConteudoById = function (id_conteudo) {
    return new Promise(async (resolve, reject) => {
      try {
        await api.get(`getFilesConteudo/${id_conteudo}`)
          .then(resp => {
            resolve(resp.data)
          })
      } catch (error) {
        reject(error)
      }
    })
  }
  this.ConteudoByIdModulo = function (id_modulo) {
    return new Promise(async (resolve, reject) => {
      try {
        await api.get(`getConteudoByIdModulo/${id_modulo}`)
          .then(resp => {
            console.log(resp.data)
            resolve(resp.data[0])
          })
      } catch (error) {
        reject(error)
      }
    })
  }
  this.ConteudoDelete = function (paramsId) {
    return new Promise((resolve, reject) => {
      try {
        api.get(`deleteConteudo/${paramsId}`)
          .then(resp => {
            resolve(resp.data[0])
          })
      } catch (error) {
        reject(error)
      }
    })
  }
}
